import { useNavigate } from "react-router-dom";
import { ArrowUpRight, ArrowDownRight } from "lucide-react";

function Sparkline({ points }) {
  let pts = points && points.length >= 2 ? points : [3.5, 3.6];
  const w = 120, h = 40, min = Math.min(...pts), max = Math.max(...pts), range = max - min || 1;
  const step = w / (pts.length - 1);
  const coords = pts.map((p, i) => [i * step, h - ((p - min) / range) * (h - 6) - 3]);
  const line = coords.map((c, i) => (i ? "L" : "M") + c[0].toFixed(1) + " " + c[1].toFixed(1)).join(" ");
  const area = `${line} L ${w} ${h} L 0 ${h} Z`;
  return (
    <svg viewBox={`0 0 ${w} ${h}`} className="w-full h-12" preserveAspectRatio="none" data-testid="dupr-sparkline">
      <path d={area} fill="rgba(190,212,69,0.15)" />
      <path d={line} fill="none" stroke="#BED445" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
}

function fmt(n) {
  return n >= 0 ? `+${n.toFixed(2)}` : n.toFixed(2);
}

function RatingPill({ label, value, delta, testid }) {
  const up = delta >= 0;
  return (
    <div className="rounded-2xl bg-white/5 border border-white/10 px-4 py-3">
      <div className="text-xs text-white/50 font-semibold">{label}</div>
      <div className="flex items-baseline gap-2">
        <span className="text-2xl font-black font-display text-white" data-testid={testid}>{value.toFixed(2)}</span>
        <span className={`text-xs font-bold inline-flex items-center ${up ? "pv-text-primary" : "text-red-300"}`}>
          {up ? <ArrowUpRight size={12} /> : <ArrowDownRight size={12} />}{fmt(delta)}
        </span>
      </div>
    </div>
  );
}

export default function PerformanceCard({ perf }) {
  const navigate = useNavigate();
  return (
    <div
      className="relative overflow-hidden rounded-3xl pv-bg-dark text-white p-6"
      data-testid="dupr-hero-card"
      style={{ backgroundImage: "radial-gradient(circle at 85% 15%, rgba(190,212,69,0.18), transparent 55%)" }}
    >
      <div className="flex items-start justify-between">
        <div>
          <div className="text-xs font-bold uppercase tracking-widest text-white/50">Your DUPR</div>
          <span className="text-6xl font-black font-display pv-text-primary leading-none block mt-1" data-testid="dupr-rating-main">
            {perf.dupr.toFixed(2)}
          </span>
        </div>
        <div className="text-right">
          <div className="inline-flex items-center gap-1 rounded-full bg-[#BED445] text-[#0E395F] px-3 py-1 text-xs font-black" data-testid="dupr-trend-badge">
            <ArrowUpRight size={14} /> {fmt(perf.doubles.delta)}
          </div>
          <div className="mt-2 text-xs text-white/50">Last 10</div>
          <div className="text-lg font-bold font-display">{perf.last10.wins}W – {perf.last10.losses}L</div>
        </div>
      </div>
      <div className="grid grid-cols-2 gap-3 mt-5">
        <RatingPill label="Doubles" value={perf.doubles.rating} delta={perf.doubles.delta} testid="doubles-rating-value" />
        <RatingPill label="Singles" value={perf.singles.rating} delta={perf.singles.delta} testid="singles-rating-value" />
      </div>
      <div className="mt-5"><Sparkline points={perf.sparkline} /></div>
      <div className="flex gap-3 mt-5">
        <button data-testid="view-stats-btn" onClick={() => navigate("/passport")} className="flex-1 bg-[#BED445] text-black font-extrabold rounded-full py-2.5 text-sm hover:bg-[#c9df55] transition-colors">
          View My Stats
        </button>
        <button data-testid="update-dupr-btn" onClick={() => navigate("/passport")} className="flex-1 border-2 border-white/25 text-white font-bold rounded-full py-2.5 text-sm hover:bg-white/10 transition-colors">
          Update DUPR
        </button>
      </div>
    </div>
  );
}
